module.exports = {"selected_device_t":"Seleccionar Dispositivo","partials":{"pot_contracted":"Pot. Contratada","pot_penalty":"Pot. Penalización","api":"Pot. Actual","current_tension":"Tensión actual","api_now":"Potencia Activa Instantánea","active_reactive":"Energía activa-reactiva","ae":"Energía Activa","ie":"Energía Reactiva","cosi":"Coseno de Phi instantáneo","historical_active_power":"Histórico potencia activa","historical_active_reactive_energy":"Histórico energía activa-reactiva"}}


//////////////////
// WEBPACK FOOTER
// ./src/translates/es/Device.json
// module id = 30
// module chunks = 1